import { render, staticRenderFns } from "./ShareBetgame.vue?vue&type=template&id=2b5efb33&scoped=true"
import script from "./ShareBetgame.vue?vue&type=script&lang=js"
export * from "./ShareBetgame.vue?vue&type=script&lang=js"
import style0 from "./ShareBetgame.vue?vue&type=style&index=0&id=2b5efb33&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5efb33",
  null
  
)

export default component.exports